import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaFlask, FaUserMd, FaShieldAlt } from "react-icons/fa";

const About = () => (
  <section id="about" className="py-5 bg-white">
    <Container>
      <Row className="align-items-center">
        {/* Görsel veya ikonlu illüstrasyon */}
        <Col md={6} className="text-center mb-4 mb-md-0 d-none d-md-block">
          <motion.img
            src="/illustration.jpg"
            alt="Majistral App Hakkında"
            className="img-fluid floating"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            style={{ maxHeight: "400px", filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.08))" }}
          />
        </Col>

        {/* Metin */}
        <Col md={6}>
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
              Hakkında
            </h2>
            <p className="text-muted mb-4" style={{ fontSize: "1.1rem" }}>
              Majistral App; eczacı, hekim ve akademisyenlere özel olarak geliştirilmiş bir majistral formül veri tabanıdır.
            </p>

            <Row className="g-4">
              <Col xs={12} sm={6}>
                <div className="d-flex align-items-start">
                  <FaFlask className="me-3" size={28} color="#2D8A7A" />
                  <div>
                    <h5 className="fw-semibold" style={{ color: "#2D8A7A" }}>
                      Majistral Formüller
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                      Her formül, hazırlanış ve kullanım bilgileriyle birlikte sizlerle.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className="d-flex align-items-start">
                  <FaUserMd className="me-3" size={28} color="#2D8A7A" />
                  <div>
                    <h5 className="fw-semibold" style={{ color: "#2D8A7A" }}>
                      Uzmanlara Özel
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                      Eczacılar, hekimler ve akademisyenler için güçlü bir bilgi ağı.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className="d-flex align-items-start">
                  <FaShieldAlt className="me-3" size={28} color="#2D8A7A" />
                  <div>
                    <h5 className="fw-semibold" style={{ color: "#2D8A7A" }}>
                      Eczacı Ürünü
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                      Eczacılar tarafından mesleki hassasiyetle geliştirilmiş bir dijital platform.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </motion.div>
        </Col>
      </Row>
    </Container>
  </section>
);

export default About;